import { render, staticRenderFns } from "./reportcase-manage-pending.vue?vue&type=template&id=3da82798&scoped=true"
import script from "./reportcase-manage-pending.vue?vue&type=script&lang=ts"
export * from "./reportcase-manage-pending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da82798",
  null
  
)

export default component.exports